/** kicker label that sits above a supplier's name. accent color, uppercase,
 * tracked. never competes with name length and reads as a category tag,
 * matching the Linear/Notion/Apple "PREVIEW"-style pattern.
 */
export function FoundingBadge() {
  return (
    <span className='text-[10px] font-semibold tracking-wider text-accent dark:text-accent-mid uppercase'>
      Founding Supplier
    </span>
  )
}
